import { render, staticRenderFns } from "./DialogConfirm.vue?vue&type=template&id=776f3bb0&"
import script from "./DialogConfirm.vue?vue&type=script&lang=js&"
export * from "./DialogConfirm.vue?vue&type=script&lang=js&"
import style0 from "./DialogConfirm.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports